<template>
  <div class="pc-product-floating-sticky-info pl-5" v-if="isScrolled">
    <div class="floating-info-container d-flex align-items-center justify-content-between p-1">
      <h1 class="secondary-heading mb-0 heading-line-height font-weight-bold" v-if="(selectedProduct && selectedProduct.sellingStyleName) || (productData && productData.sellingStyleName)">
        {{ isRug ? selectedProduct.sellingStyleName : productData.sellingStyleName }}
      </h1>
      <p class="color-light-grey mb-0 ml-3" v-if="sellingStyleNumber">{{ sellingStyleNumber }}</p>
      <p class="mb-0 ml-3">{{ getImperialDisplayValue? getImperialDisplayValue: selectedProduct.productSizeImperial }}</p>
      <div class="px-2 text-uppercase ml-3" v-if="collectionRedirect || (productData && productData.collectionCode)">
        <a class="collection-link" :href="collectionRedirect
          ? collectionRedirect
          : '/product-collection/' + getCollectionLink(productData.collectionCode.description, productData.collectionCode.code)">
          {{ productData.collectionCode.description }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PCSpecificationsRating from "./pc-product-color-variation.vue";

export default {
  props: ["collectionRedirect"],
  data() {
    return {
      isScrolled: false,
      isMouseAtTop: false,
    };
  },
  components: {
    "pc-product-color-variation": PCSpecificationsRating,
  },
  computed: {
    ...mapGetters({
      rugsSizesOptions: "productDetail/rugsSizesOptions",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      selectedColor: "productDetail/color",
      productData: "productDetail/productData",
      isRug: "productDetail/isRug",
      selectedProduct: "productDetail/selectedProduct",
      isComingSoonProduct: "productDetail/isComingSoonProduct",
      getImperialDisplayValue: "productDetail/getImperialDisplayValue"
    }),
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('mousemove', this.handleMouseMove);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('mousemove', this.handleMouseMove);
  },
  methods: {
    ...mapActions({
      changeRugsSize: "productDetail/changeRugsSize",
    }),

    handleScroll() {
      this.isScrolled = window.scrollY > 300;
    },

    handleMouseMove(event) {
      this.isMouseAtTop = event.clientY < 100;
    },

    changeRugs(event) {
      const newStyleNumber = event.target.value;
      this.changeRugsSize(newStyleNumber);
      const url = new URL(window.location);
      window.history.replaceState(
        null,
        null,
        `/product/detail/${this.selectedProduct?.styleNameURL}-${newStyleNumber}/${this.selectedColor?.colorNumber}${url.searchParams ? "?" + url.searchParams?.toString() : ""}`
      );
    },
    getCollectionLink(description, code) {
      return description?.includes('&') ? (code ?? '') : description;
    }
  },
};
</script>

